import uuidv4 from 'uuid/v4';
import { logError } from '@zg-rentals/log-error';
import { FULLSTORY, trackToFullStory } from './fullstory';

/**
 * Track an error to logging services (FullStory, log-error)
 * @param error - The error object
 * @param additionalData - Additional context data
 */
export function trackError(error: Error, additionalData: object = {}) {
  const leasingWebErrorId = uuidv4();

  const fullStoryUrl = trackToFullStory(FULLSTORY.ERROR, { leasingWebErrorId }, undefined);

  const context = {
    leasingWebErrorId,
    fullStoryUrl,
    ...additionalData,
  };

  logError({ error, context: { details: 'trackError', ...context } });
}
